import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AddressComponent } from '@app/components/address/address.component';
import { InvalidControlScrollDirective } from '@app/directives/invalid-control-scroll.directive';
import { PlatformModule } from '@app/platform.module';
import { AppCommonModule } from '@common/common.module';
import { EmployeeFormsModule } from '@forms/employees/employee-forms.module';
import { Components } from '@self-serve/components';
import { CalendarButtonComponent } from '@self-serve/components/calendar-button/calendar-button-component';
import { Services } from '@self-serve/services';
import { Views } from '@self-serve/views';
import { DashboardModule } from '../dashboard/dashboard.module';
import { CompanyFormsModule } from '../forms/company/company-forms.module';
import { KYCKYBBadge } from '../payroll/components/kyc-kyb/kyc-kyb-badge/kyc-kyb-badge.component';
import { PayrollModule } from '../payroll/payroll.module';
import { TableModule } from '../table/table.module';
import { SelfServeRouterModule } from './self-serve.routes';

@NgModule({
    imports: [
        SelfServeRouterModule,
        CommonModule,
        FormsModule,
        CompanyFormsModule,
        ReactiveFormsModule,
        AppCommonModule,
        PlatformModule,
        PayrollModule,
        TableModule,
        AddressComponent,
        InvalidControlScrollDirective,
        CalendarButtonComponent,
        DashboardModule,
        EmployeeFormsModule,
        KYCKYBBadge,
    ],
    providers: [...Services],
    declarations: [...Views, ...Components],
})
export class SelfServeModule {}
